import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const SideNavigationItem = ({ linkToPath, currentPath, activeImg, inactiveImg, label }) => {
  const isActive = currentPath.includes(linkToPath);

  return (
    <Link to={linkToPath}>
      <div className={`sidebar-tab-container ${isActive ? 'active' : ''}`}>
        <img
          src={isActive ? activeImg : inactiveImg}
          alt="sidenav-item-icon"
          className="icon"
        ></img>
        <p>{label}</p>
      </div>
    </Link>
  );
};

SideNavigationItem.propTypes = {
  linkToPath: PropTypes.string,
  currentPath: PropTypes.string,
  activeImg: PropTypes.string,
  inactiveImg: PropTypes.string,
  label: PropTypes.string,
};

export default SideNavigationItem;
